export default "__VITE_ASSET__C$vn87Hv__"